import {
  HelpCircle,
  MessageSquare,
  BarChart3,
  Shield,
  Sparkles,
  Play,
  Settings,
  FileText,
} from 'lucide-react';

/** Standard 9-tab Help layout used across RCM Platform services. */
export const STANDARD_HELP_TABS = [
  { id: 'getting-started', label: 'Getting Started', icon: Play },
  { id: 'workflows', label: 'Core Workflows', icon: FileText },
  { id: 'ai-assistant', label: 'AICoworker(Kai)', icon: MessageSquare },
  { id: 'analytics', label: 'Analytics & Operational KPIs', icon: BarChart3 },
  { id: 'analytics-faq', label: 'Analytics FAQ', icon: BarChart3 },
  { id: 'features', label: 'Features', icon: Sparkles },
  { id: 'faq', label: 'FAQ', icon: HelpCircle },
  { id: 'settings', label: 'Settings', icon: Settings },
  { id: 'troubleshooting', label: 'Troubleshooting', icon: Shield },
];

export const DEFAULT_HELP_TAB = 'getting-started';
